import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const outline = defineConnector({
  identifier: "outline",
  name: "Outline",
  tagLine: "Knowledge base and wiki",
  logo,
  protocol: "http",
  tags: ["documents"],
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Outline API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Outline, go to **Settings > API** and create a new personal API key.",
        },
      ],
    },
    {
      title: "Enter your Outline details",
      items: [
        {
          kind: "url",
          label: "Outline instance URL",
          required: true,
          placeholder: "https://app.getoutline.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Outline instance.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => ({
      url: `${instanceUrl}/api/auth.info`,
      method: "POST",
    }),
  },
});
